import axios from "axios";
import { isTokenValid } from "utils/jwt";
import { getOrSetSessionId } from "utils/session";
import { getJwt } from "./guestServiceInstance";

const getCurrentLanguage = () => {
  const locale = window.location.pathname.split("/")[1];

  return ["en", "id", "zh", "ja", "ko"].includes(locale) ? locale : "en";
};

const instance = axios.create({
  baseURL: process.env.GATSBY_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  function (config) {
    const jwt = isTokenValid() && getJwt();
    config.headers.AUTH_TOKEN = getOrSetSessionId();
    config.headers.LOCALE = getCurrentLanguage();
    config.headers.CURRENCY = "IDR";

    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default instance;
